import { Typography } from "@mui/material";
import React from "react";

type Props = {
  children: React.ReactNode;
};

export const DynamicFormFieldHeading = (props: Props) => {
  return (
    <Typography component="h5" variant="h5">
      {props.children}
    </Typography>
  );
};
